
import { useContext } from "react";
import { Redirect } from "react-router-dom";
import { PageWrapper } from "../../components/PageWrapper";
import PremiumForm from "../../components/vlink/PremiumForm";
import RevisionForm from "../../components/vlink/RevisionForm";
import ProfileHeader from "../../components/ProfileHeader";
import { AuthContext } from "../../context/AuthContext";
import { VendorFormsWrapper } from "./VendorDetails";

export default function VendorDetailsPreview() {
    const {
        context: { user },
        isVLinkVendor,
    } = useContext(AuthContext);

    let context = isVLinkVendor(user) ? 'VENDOR_PREVIEW' : null;

    if(context == null) {
        return <Redirect to="/vlink/dashboard" />
    }

    return (
        <PageWrapper>
            <ProfileHeader context={context} level='VENDOR' />
            <VendorFormsWrapper>
                <RevisionForm 
                    context={context} 
                    level='VENDOR'
                />
                <PremiumForm context={context} level='VENDOR'/>
            </VendorFormsWrapper>
        </PageWrapper>
    )
}